import Vue from 'vue'

import SwiperControls from '~/components/global/swiper/SwiperControls'
import TaxNotification from '~/components/global/TaxNotification'
import Link from '~/components/global/Link'

// Selectel components
import SPreloader from '~/components/global/selectel/SPreloader'
import SAccordion from '~/components/global/selectel/accordion/SAccordion'
import SAccordionItem from '~/components/global/selectel/accordion/SAccordionItem'
import SDocument from '~/components/global/selectel/SDocument'
import SLabel from '~/components/global/selectel/SLabel'
import SSection from '~/components/global/selectel/SSection'
import SOverlay from '~/components/global/selectel/SOverlay'
import SAlert from '~/components/global/selectel/SAlert'

// alert
import SAlertTranslation from '~/components/common/alerts/SAlertTranslation'

Vue.component('SwiperControls', SwiperControls)
Vue.component('TaxNotification', TaxNotification)
Vue.component('CustomLink', Link)

Vue.component('SPreloader', SPreloader)
Vue.component('SAccordion', SAccordion)
Vue.component('SAccordionItem', SAccordionItem)
Vue.component('SDocument', SDocument)
Vue.component('SLabel', SLabel)
Vue.component('SOverlay', SOverlay)
Vue.component('SAlert', SAlert)
Vue.component('SSection', SSection)
Vue.component('SAlertTranslation', SAlertTranslation)
